import { render, staticRenderFns } from "./addDepartment.vue?vue&type=template&id=f033718c&scoped=true&"
import script from "./addDepartment.vue?vue&type=script&lang=js&"
export * from "./addDepartment.vue?vue&type=script&lang=js&"
import style0 from "./addDepartment.vue?vue&type=style&index=0&id=f033718c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f033718c",
  null
  
)

export default component.exports